import { LoadingSpinner } from '@components/Generic'
import axios from 'axios'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { Intro } from '@components/ResumeFromEmail/steps/Intro'
import { Otp } from '@components/ResumeFromEmail/steps/Otp'
import { Error } from '@components/ResumeFromEmail/steps/Error'
import { devLog } from '@methods/devLog'
import { getUrlParam } from '@methods/urlParams'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@constants/apiUrl'

export interface GetResumeFromEmailContextResponse {
  maskedPhoneNumber: string
  sendResumptionEndpoint: string
  enterResumptionEndpoint: string
  resumeWithOtpEndpoint: string
  otpMaxAttempts: number
  smsMaxAttempts: number
  smsRetrySeconds?: number
}

export const ResumeFromEmailPage = observer(() => {
  const store = useContext(StoreContext)

  const [step, setStep] = useState(0)
  const [attemptsLeft, setAttemptsLeft] = useState<number | undefined>(undefined)
  const [context, setContext] = useState<GetResumeFromEmailContextResponse | undefined>()

  const nextStep = () => {
    setStep(step + 1)
  }

  const initComponent = async () => {
    const otpAttemptsLeft = getUrlParam('otpAttemptsLeft')

    try {
      const { data } = await axios.get<GetResumeFromEmailContextResponse>(
        `${API_URL}/${ONBOARDING_SERVICE_PATH}/get-resume-transaction-context`,
        {
          withCredentials: true,
        }
      )

      devLog(data)
      setContext(data)

      if (otpAttemptsLeft) {
        setAttemptsLeft(Number(otpAttemptsLeft))
        setStep(Number(otpAttemptsLeft) === 0 ? 3 : 2)
      } else {
        nextStep()
      }
    } catch (error) {
      devLog(error)
      setStep(3)
    }
  }

  useEffect(() => {
    devLog('initComponent')
    void initComponent()
  }, [])

  const renderCurrentStep = () => {
    if (!context) {
      if (step === 3) return <Error />

      return <LoadingSpinner />
    }

    switch (step) {
      case 0:
        return (
          <>
            <LoadingSpinner />
          </>
        )
      case 1:
        return (
          <Intro
            nextStep={nextStep}
            phoneNumber={context.maskedPhoneNumber}
            sendOtpUrl={context.sendResumptionEndpoint}
          />
        )
      case 2:
        return (
          <Otp
            maxAttempts={context.otpMaxAttempts}
            attemptsLeft={attemptsLeft ?? 0}
            formActionUrl={context.resumeWithOtpEndpoint}
            sendOtpUrl={context.sendResumptionEndpoint}
            smsMaxAttempts={context.smsMaxAttempts}
            smsRetrySeconds={context.smsRetrySeconds}
            isSmsEnabled={true}
          />
        )
      case 3:
        return <Error />

      default:
        return <></>
    }
  }

  return <div className="page-container mobile-m-0">{renderCurrentStep()}</div>
})
